import { FunctionComponent } from "react";
import {
  AppBar as MuiAppBar,
  AppBarProps,
  Grid,
  IconButton as MuiIconButton,
  Toolbar,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { HeaderActions } from "components/organisms/header-actions";
import styled from "@emotion/styled";
import { connect } from "react-redux";
import { Dispatch, RootState } from "core/store/store.types";
import { User } from "core/types/user.types";
import { authSelectors } from "core/store/modules/auth";

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

interface OwnProps {
  onSignOut: () => void;
  onDrawerToggle?: React.MouseEventHandler<HTMLElement>;
  onButtonClick: () => void;
}

interface StateProps {
  user?: User;
}

interface DispatchProps {}

export type Props = OwnProps & StateProps & DispatchProps;

const Header: FunctionComponent<AppBarProps & Props> = ({
  onSignOut,
  onDrawerToggle,
  onButtonClick,
  user,
  ref,
  ...otherProps
}) => {
  return (
    <AppBar position="sticky" elevation={0} ref={ref} {...otherProps}>
      <Toolbar>
        <Grid container alignItems="center">
          <Grid item sx={{ display: { xs: "block", md: "none" } }}>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={onDrawerToggle}
              size="large"
            >
              <MenuIcon />
            </IconButton>
          </Grid>
          <Grid item></Grid>
          <Grid item xs />
          <Grid item>
            <HeaderActions
              user={user}
              onSignOut={onSignOut}
              onButtonClick={onButtonClick}
            />
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  (state: RootState) => ({
    user: authSelectors.getUser(state),
  }),
  (dispatch: Dispatch) => ({})
)(Header);
